(function () {
  if (window.__mbRows) return;
  window.__mbRows = true;
  var KEY = 'mb_recently_viewed';
  var MAX = 16;
  var uid = 0;
  var FAM = [
    ['Earrings', 'Ear Cuffs'],
    ['Rings'],
    ['Bracelets', 'Bangles', 'Chain Bracelets'],
    ['Pendant Set', 'Pendants'],
    ['Necklace Set', 'Necklaces', 'Necklace', 'Temple Jewellery Set', 'Antique Temple Jewellery', 'AD Jewellery Set', 'Kundan Jewellery Set', 'Antique Jewellery']
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function readRV() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'number'; }) : [];
    } catch (e) { return []; }
  }
  function writeRV(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }
  function family(t) {
    for (var i = 0; i < FAM.length; i++) if (FAM[i].indexOf(t) > -1) return FAM[i];
    return t ? [t] : [];
  }
  function fetchCards(searchUrl, q, extra) {
    var prefix = 'mbc' + (++uid) + 'x';
    var url = searchUrl + (searchUrl.indexOf('?') > -1 ? '&' : '?') +
      'section_id=mb-product-cards&type=product&options%5Bunavailable_products%5D=hide&q=' +
      encodeURIComponent(q) + (extra || '');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html.split('mbcardsX').join(prefix), 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-product-id]'));
      });
  }

  function initArrows(root) {
    (root || document).querySelectorAll('[data-mb-row]').forEach(function (row) {
      var list = row.querySelector('.mb-row__list--slider');
      var prev = row.querySelector('[data-mb-prev]');
      var next = row.querySelector('[data-mb-next]');
      if (!list || !prev || !next) return;
      function upd() {
        var scrollable = list.scrollWidth > list.clientWidth + 4;
        row.classList.toggle('mb-row--static', !scrollable);
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      }
      if (!row.__mb) {
        row.__mb = true;
        var step = function (dir) {
          var item = list.querySelector('.mb-row__item');
          var w = item ? item.getBoundingClientRect().width + 16 : 300;
          list.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
        };
        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        list.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
      }
      upd();
    });
  }

  function initRV() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-mb-rv]'));
    if (!els.length) return;
    var list = readRV();
    var cur = null;
    els.forEach(function (el) {
      var c = parseInt(el.getAttribute('data-current-id'), 10);
      if (c) cur = c;
    });
    if (cur) {
      list = [cur].concat(list.filter(function (x) { return x !== cur; }));
      writeRV(list);
    }
    els.forEach(function (el) {
      var limit = Math.min(parseInt(el.getAttribute('data-limit'), 10) || 10, 12);
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var ids = list.filter(function (x) { return x !== cur; }).slice(0, limit);
      if (ids.length < min) return;
      var load = function () {
        fetchCards(el.getAttribute('data-search-url'), ids.map(function (i) { return 'id:' + i; }).join(' OR '))
          .then(function (lis) {
            var by = {};
            lis.forEach(function (li) { by[li.getAttribute('data-product-id')] = li; });
            var ul = el.querySelector('[data-mb-rv-list]');
            var n = 0;
            ids.forEach(function (id) {
              if (by[id]) { ul.appendChild(by[id]); n++; }
            });
            if (n >= min) { el.hidden = false; initArrows(el); }
          })
          .catch(function () {});
      };
      load();
    });
  }

  function initRelated() {
    var el = document.querySelector('product-recommendations[data-mb-type]');
    if (!el || el.__mb) return;
    el.__mb = true;
    var fam = family(el.getAttribute('data-mb-type'));
    if (!fam.length) return;
    var cur = el.getAttribute('data-product-id');
    var want = parseInt(el.getAttribute('data-mb-limit'), 10) || 8;
    var price = (parseInt(el.getAttribute('data-mb-price'), 10) || 0) / 100;
    var searchUrl = el.getAttribute('data-mb-search-url');
    var busy = false;
    var timer = null;
    function inFam(li) { return fam.indexOf(li.getAttribute('data-product-type')) > -1; }
    function grid() { return el.querySelector(':scope > ul.product-grid'); }
    function evaluate() {
      if (busy) return;
      busy = true;
      var ul = grid();
      if (ul) ul.setAttribute('data-mb-done', '1');
      var recs = ul ? Array.prototype.slice.call(ul.children) : [];
      var same = recs.filter(inFam);
      if (same.length >= Math.min(5, want)) {
        recs.filter(function (li) { return !inFam(li); }).forEach(function (li) { ul.appendChild(li); });
        busy = false;
        return;
      }
      var q = fam.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ');
      var band = price ? '&filter.v.price.gte=' + Math.floor(price * 0.5) + '&filter.v.price.lte=' + Math.ceil(price * 2) : '';
      fetchCards(searchUrl, q, band)
        .then(function (lis) {
          lis = lis.filter(function (li) { return li.getAttribute('data-product-id') !== cur && inFam(li); });
          if (lis.length >= 4 || !band) return lis;
          return fetchCards(searchUrl, q, '').then(function (more) {
            return lis.concat(more.filter(function (li) { return li.getAttribute('data-product-id') !== cur && inFam(li); }));
          });
        })
        .then(function (lis) {
          if (!lis.length) return;
          var ulNow = grid();
          if (!ulNow) {
            var shell = el.querySelector('template[data-mb-related-shell]');
            if (!shell) return;
            el.appendChild(shell.content.cloneNode(true));
            ulNow = grid();
            if (!ulNow) return;
          }
          ulNow.setAttribute('data-mb-done', '1');
          var current = Array.prototype.slice.call(ulNow.children);
          var seen = {};
          var out = [];
          lis.concat(current).forEach(function (li) {
            var id = li.getAttribute('data-product-id');
            if (!id || id === cur || seen[id] || out.length >= want) return;
            seen[id] = 1;
            li.className = 'grid__item';
            out.push(li);
          });
          while (ulNow.firstChild) ulNow.removeChild(ulNow.firstChild);
          out.forEach(function (li) { ulNow.appendChild(li); });
          el.classList.add('product-recommendations--loaded');
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    var mo = new MutationObserver(function () {
      var ul = grid();
      if (ul && !ul.hasAttribute('data-mb-done')) {
        clearTimeout(timer);
        evaluate();
      }
    });
    mo.observe(el, { childList: true });
    if (grid()) { evaluate(); return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) {
          io.disconnect();
          timer = setTimeout(function () { if (!grid()) evaluate(); }, 2500);
        }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(el);
    } else {
      timer = setTimeout(function () { if (!grid()) evaluate(); }, 4000);
    }
  }

  ready(function () {
    initArrows();
    initRV();
    initRelated();
  });
})();
